// Derives folder segments from storage path templates and resolved document paths.

const PLACEHOLDER_MARKER = '{{'

const splitSegments = (path: string): string[] =>
  path
    .split('/')
    .map((segment) => segment.trim())
    .filter((segment) => segment.length > 0)

/** Folder segments from a StoragePath template, up to the first `{{` placeholder. */
export const folderSegmentsFromTemplate = (path?: string | null): string[] => {
  if (!path) return []

  const segments = splitSegments(path)
  const firstPlaceholderIndex = segments.findIndex((segment) => segment.includes(PLACEHOLDER_MARKER))

  if (firstPlaceholderIndex === -1) {
    return segments.slice(0, -1)
  }

  return segments.slice(0, firstPlaceholderIndex)
}

/** Folder segments from a resolved document path (last segment is the filename). */
export const folderSegmentsFromResolvedPath = (path?: string | null): string[] => {
  if (!path) return []

  return splitSegments(path).slice(0, -1)
}
